import { render, staticRenderFns } from "./FiltroMultiplaCotas.vue?vue&type=template&id=4bf84fec&scoped=true&"
import script from "./FiltroMultiplaCotas.vue?vue&type=script&lang=js&"
export * from "./FiltroMultiplaCotas.vue?vue&type=script&lang=js&"
import style0 from "./FiltroMultiplaCotas.vue?vue&type=style&index=0&id=4bf84fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf84fec",
  null
  
)

export default component.exports